import * as yup from 'yup';

import {
  EMAIL_VALIDATION_REGEX,
  ERROR_INVALID_EMAIL,
  ERROR_REQUIRED_FIELD_WITH_NAME,
} from '@/constants';
import { IForgotPasswordPayload } from '@/interfaces';

import { createNameofProxy } from '@/lib/ui';

export const FORGOT_PASSWORD_SCHEMA = yup.object().shape({
  email: yup
    .string()
    .required(ERROR_REQUIRED_FIELD_WITH_NAME('ST Engineering email'))
    .matches(EMAIL_VALIDATION_REGEX, ERROR_INVALID_EMAIL),
}) as yup.ObjectSchema<IForgotPasswordPayload>;

export const FORGOT_PASSWORD_FORM_FIELDS = createNameofProxy<IForgotPasswordPayload>();
